import paths from 'constants/paths'

const myPaths = {
  ...paths,
  help: '/help/'
}

export default myPaths
